import TutorialListPage from './list/'
import TutorialAddPage from './add/'
import TutorialViewPage from './view/'

export default {
  TutorialListPage,
  TutorialViewPage,
  TutorialAddPage
}
